module.exports = __webpack_public_path__ + "img/ceo2.ab3715d2.jpg";